export const StyleTable = {
    headRow: {
        style: {
            border: 'none',
        },
    },
    headCells: {
        style: {
            color: '#eef8ff',
            fontSize: '12px',
            backgroundColor: "#104aa5",
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: '#eaf1fb',
            borderBottomColor: '#FFFFFF',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
            marginTop: "20px",
            borderRadius: '10px',
        },
    },
    table: {
        style: {
            border: '1px solid #eef2f7',
        },
    },
    expanderHeader: {
        style: {
            backgroundColor: '#000', // Color de fondo para la cabecera del expansor

        },
    },
};